import { createApi } from "@reduxjs/toolkit/query/react";

import { IPayroll, IPayrollPart1 } from "@/interfaces/payroll.interface";
import { BaseWithAuth, getWorkspace } from "@/utils/helpers";

// type TPayrollQueryParams = {
//   customerId?: string;
//   projectId?: string;
//   startDate?: string;
//   endDate?: string;
// };

type TUpdatePayroll = {
  id?: string;
  time?: number;
  empId?: string;
  date?: string | Date;
  workshiftId?: string;
};

export const payrollApi = createApi({
  reducerPath: "payrollApi",
  baseQuery: BaseWithAuth(),
  tagTypes: ["payroll", "part-1"],
  endpoints: (builder) => ({
    getPayrolls: builder.query<GeneralResponse<IPayroll[]>, string>({
      query: (query) => `workspace/${getWorkspace()}/payroll${query}`,
      providesTags: ["payroll"],
      // transformResponse: (response: APIResponse<IPayroll[]>) => response?.data,
    }),
    getPayrollsPart1: builder.query<GeneralResponse<IPayrollPart1[]>, string>({
      query: (query: string) =>
        `workspace/${getWorkspace()}/payroll/part1${query}`,
      providesTags: ["part-1"],
      // transformResponse: (response: APIResponse<IPayrollPart1[]>) =>
      //   response?.data,
    }),
    updatePayrollPart1: builder.mutation<object, { data: TUpdatePayroll[] }>({
      query: ({ data }) => ({
        url: `/workspace/${getWorkspace()}/payroll/part1`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["part-1"],
    }),
  }),
});
export const {
  useGetPayrollsQuery,
  useGetPayrollsPart1Query,
  useUpdatePayrollPart1Mutation,
} = payrollApi;
